module.exports = __webpack_public_path__ + "static/media/cor.80de59d7.jpeg";